import { _isOnScreen, _on, _scrollTo } from '../../utils';

const backToTop = document.querySelector('.back-to-top');

_isOnScreen(
  '.header__beacon',
  () => backToTop.classList.add('hidden'),
  {},
  () => backToTop.classList.remove('hidden'),
);

_on('click', 'js--back-to-top', () => {
  _scrollTo('.header__beacon', { threshold: 72 + 60 });
});
